import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Works.css';

const Works = () => {
  const { t, isRTL } = useLanguage();

  // Define all tiles in an array
  const tiles = [
    // Vision
    {
      key: 'vision',
      icon: 'fa-lightbulb',
      title: t.works.vision,
      content: (
        <b>
          <p className="works-text works-text-info">
            {t.works.visionText}
          </p>
        </b>
      )
    },
    // Mission
    {
      key: 'mission',
      icon: 'fa-clipboard',
      title: t.works.mission,
      content: (
        <p className="works-text works-text-info" style={{ maxWidth: '91%', fontWeight: 600 }}>
          <b>{t.works.missionText}</b>
        </p>
      )
    },
    // Goals
    {
      key: 'goals',
      icon: 'fa-chart-line',
      title: t.works.goals,
      content: (
        <div className="works-text">
          <b>
            {t.works.goalsItems.map((item, index) => (
              <div key={index} className="works-text-info goals-item">
                <span>-</span> {item}
              </div>
            ))}
          </b>
        </div>
      )
    },
    // Corporate Values
    {
      key: 'values',
      icon: 'fa-briefcase',
      title: t.works.values,
      content: (
        <div className="works-text">
          <b>
            {t.works.valuesItems.map((item, index) => (
              <div key={index} className="works-text-info values-item">
                <span>-</span> <span style={{ color: 'red', fontWeight: 'bold' }}>{item.highlight}</span> {item.text}
              </div>
            ))}
          </b>
        </div>
      )
    }
  ];

  // Reverse the tiles array if RTL
  const displayTiles = isRTL ? [...tiles].reverse() : tiles;

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="sora-works-box" id="section-3">
        <div className={`works-wrap row ${isRTL ? 'rtl-works' : ''}`}>
          <div className="works-title">
            <h4>{t.works.title}</h4>
            <span></span>
          </div>
          <div style={{ clear: 'both' }} />

          {displayTiles.map((tile, index) => (
            <div key={tile.key} className="works-tiles" data-wow-delay={`${index * 0.2}s`}>
              <span className="works-icons">
                <li data-percent={(index + 1) * 25}>
                  <span className="text">
                    <i aria-hidden="true" className={`fa ${tile.icon}`} />
                  </span>
                </li>
              </span>
              <h6 className="works-heading">{tile.title}</h6>
              {tile.content}
            </div>
          ))}

          <div style={{ clear: 'both' }} />
        </div>
      </div>
    </>
  );
};

export default Works;
